export default __webpack_public_path__ + "media/images/dispenser-splat-8dd801e67bc2c3258c94eb97cd629a3b.svg";